import { ActionExtended } from '../../_common/interfaces/ActionExtended';
import { User } from '../../_common/interfaces/models/user';
import { ACTIONS } from '../../_config'

export interface UserReducer {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  role: string | null;
  permissions: any;
  selectedCountry: any;
  countries: any[];
  menus?: any[];
}

const initialState: UserReducer = {
  user: null,
  token: null,
  isAuthenticated: false,
  role: null,
  permissions: null,
  selectedCountry: null,
  countries: [],
  menus: [],
};

const userReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.AUTH.VERIFY_OTP:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token || localStorage.getItem('eh-ui-auth-key'),
        isAuthenticated: true,
        role: action.payload.role || null,
      };

    case ACTIONS.ACCOUNT.MY_ACCOUNT_UPDATE:
      return {
        ...state,
        user: action.payload.user,
      };

    case ACTIONS.GEN_INFO.COUNTRY_LIST:
      return {
        ...state,
        countries: action.payload.countries,
      };

    case ACTIONS.GEN_INFO.SELECTED_COUNTRY:
      return {
        ...state,
        selectedCountry: action.payload.selectedCountry,
      };
    case ACTIONS.GEN_INFO.MENU_LIST:
      return {
        ...state,
        menus: action.payload.menus,
      };

    case ACTIONS.AUTH.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        role: null,
      };
    default:
      return state;
  }
};

export default userReducer;
